import type { Messages } from "../../catalog";
import { modulesMessages } from "./modules";
import { viewerMessages } from "./viewer";

export const messages: Messages = { ...viewerMessages, ...modulesMessages };
